import {NgModule} from '@angular/core';
import {Route, RouterModule} from '@angular/router';
import {NotFoundComponent} from './not-found.component';
import {AuthGuard} from './auth/auth-guard.service';
import {provideMatomo, withRouter} from 'ngx-matomo-client';


const ROUTES = [
  {path: '', pathMatch: 'full', redirectTo: '/angebot'},
  {path: '', loadChildren: () => import('./auth')},
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => [
      {path: 'admin', loadChildren: () => import('./admin')},
      {path: 'angebot', loadChildren: () => import('./angebot')},
      {path: 'auftraggeber', loadChildren: () => import('./auftraggeber')},
      {path: 'student', loadChildren: () => import('./student')},
      {path: 'vermittlung', loadChildren: () => import('./vermittlung')},
    ]
  },
  {path: '**', component: NotFoundComponent}
] as Route[];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES, {onSameUrlNavigation: 'reload'})],
  providers: [
    provideMatomo({
      acceptDoNotTrack: false,
      trackerUrl: '/api/',
      trackerUrlSuffix: 'stats',
      scriptUrl: '/api/stats',
      enableJSErrorTracking: true,
      siteId: 6
    }, withRouter())
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
